// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"16b81605","214":"a79b3628","275":"b5e5c007","406":"5ce39c93","515":"d6f9dcce","659":"615b356b","723":"84be408d","748":"38abda3d","812":"146a4a59","960":"f2a1ea8a"}[chunkId] + ".chunk.js";
};